import Vue from 'vue'
import { VueHammer } from 'vue2-hammer'

// @ts-ignore
Vue.use(VueHammer)
